import React from "react";

export type Role = "user" | "admin";

export const RoleContext = React.createContext<Role>("user");
export const useRole = () => React.useContext(RoleContext);
